export default {
  apiurl: "https://authenticator.truncus.eu/"
  // openkycurl: 'https://openkyc.live/'
};
